var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.5H19C24.2467 4.5 28.5 8.7533 28.5 14V21.5H24.8098C24.9346 20.8525 25 20.1839 25 19.5C25 13.701 20.299 9 14.5 9H13.5C12.3786 9 11.2947 9.1605 10.2701 9.45978C11.6128 6.53284 14.569 4.5 18 4.5ZM8.4003 10.1897C9.61458 6.03496 13.4529 3 18 3H19C25.0751 3 30 7.92487 30 14V21.5V23H28.5H24.4025C22.9611 27.0782 19.0718 30 14.5 30H3.5H2V28.5V20.5C2 15.9802 4.6075 12.0693 8.4003 10.1897ZM13.5 10.5H14.5C19.4706 10.5 23.5 14.5294 23.5 19.5C23.5 24.4706 19.4706 28.5 14.5 28.5H3.5V20.5C3.5 14.9772 7.97715 10.5 13.5 10.5ZM9 19H14V17.5H9V19ZM17.75 23.5H9V22H17.75V23.5Z",
    fill: "#585D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.c9fd6e728d009858680721f45932f1c9.svg";
export { ForwardRef as ReactComponent };